import { render, staticRenderFns } from "./Warrants.vue?vue&type=template&id=153ea056&scoped=true"
import script from "./Warrants.vue?vue&type=script&lang=js"
export * from "./Warrants.vue?vue&type=script&lang=js"
import style0 from "./Warrants.vue?vue&type=style&index=0&id=153ea056&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "153ea056",
  null
  
)

export default component.exports